import * as React from 'react';
import { Flex, FlexDirection } from 'src/components/Flex/Flex';
import styled from 'styled-components';
import { FlexPosition, Color } from '../Globals/Globals';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ICollapsibleContainerProps {
  /** Text that is shown inside the container */
  text: string;
  /** Is the container initially collapsed */
  collapsed?: boolean;
}

interface ICollapsibleContainerState {
  collapsed: boolean;
}

interface ICollapsibleWrapperProps {
  collapsed: boolean;
  showCollapseButton: boolean;
}

const CollapsibleWrapper = styled.span<ICollapsibleWrapperProps>`
  height: ${props => (props.collapsed || !props.showCollapseButton ? `100%` : `8em`)};
  overflow-y: hidden;
`;

const CollapsibleButtonWrapper = styled(Flex)`
  padding-top: 0.2em;
  padding-bottom: 0.2em;
  border: ${Color.lightBlue} solid;
  color: ${Color.lightBlue};
  border-radius: 0.2em;
  line-height: 0;
  cursor: pointer;

  &:hover {
    background: ${Color.lightBlue};
    color: ${Color.white};
  }
`;

/** Container that has a button to hide and collapse the content if the content length exceeds 250 characters.  */
export class CollapsibleContainer extends React.Component<
  ICollapsibleContainerProps,
  ICollapsibleContainerState
> {
  // Is collapsible after content length exceeds this value.
  private MAXCHARACTERS = 250;

  constructor(props: ICollapsibleContainerProps) {
    super(props);

    this.state = {
      collapsed: props.collapsed ? true : false
    };
  }

  public render() {
    const showCollapseButton = this.props.text.length > this.MAXCHARACTERS;
    return (
      <Flex direction={FlexDirection.column}>
        <CollapsibleWrapper
          collapsed={this.state.collapsed}
          showCollapseButton={showCollapseButton}
        >
          {this.props.text}
        </CollapsibleWrapper>
        {showCollapseButton && (
          <CollapsibleButtonWrapper
            alignHorizontal={FlexPosition.center}
            alignVertical={FlexPosition.center}
            onClick={() => this.setState({ collapsed: !this.state.collapsed })}
          >
            <FontAwesomeIcon
              icon={this.state.collapsed ? 'angle-double-up' : 'angle-double-down'}
            />
          </CollapsibleButtonWrapper>
        )}
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CollapsibleContainer/CollapsibleContainer.tsx